import * as React from 'react';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
var styles = require('./MailListLoading.scss');
var MailListLoading = function () { return React.createElement(Spinner, { className: styles.spinner }); };
export default MailListLoading;
//# sourceMappingURL=MailListLoading.js.map